module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0144.jpg?v=50b0e951";